"use strict";
/*
 * Created on 01 16 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Represents single item of {@link ProductVATByProduct aggregation by product}.
 *
 * @author JMe
 */


var ProductVATByProductData =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ProductVATByProductData, _DomainObject_1$Domai);

  /**
   * @param vatId the internal id of {@link VAT vat entity}, use it to lookup for rates.
   * @param validFrom the start date of validity (corresponds with validity of {@link VATRate.rate})
   * @param validTo the end date of validity (corresponds with validity of {@link VATRate.rate})
   */
  function ProductVATByProductData(vatId, validFrom, validTo) {
    var _this;

    _classCallCheck(this, ProductVATByProductData);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductVATByProductData).call(this));
    _this.vatId = vatId;
    _this.validFrom = validFrom;
    _this.validTo = validTo;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(ProductVATByProductData, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new ProductVATByProductData(mat.vatId, mat.validFrom, mat.validTo);
    }
  }]);

  return ProductVATByProductData;
}(DomainObject_1.DomainObject);

exports.ProductVATByProductData = ProductVATByProductData;

ProductVATByProductData.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ProductVATByProductData.name);
  return {
    vatId: builder.id('vatId'),
    validFrom: builder.date('validFrom', DateParser_1.DateParser.ISO_PATTERN),
    validTo: builder.date('validTo', DateParser_1.DateParser.ISO_PATTERN)
  };
}();